import { Button, Tooltip, toast } from "@/components/ui";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/Dropdown";
import { TRACKERS } from "@/constants/Trackers";
import { trackEvent } from "@/lib/tracking";
import { useParams } from "@tanstack/react-router";
import { CirclePlus, NotebookPen } from "lucide-react";
import { useState } from "react";
import { SectionHeader } from "../components/SectionHeader";
import { HealthMaintenanceMiscellaneous } from "./components/HealthMaintenanceMiscellaneous";
import { HealthMaintenanceScreenings } from "./components/HealthMaintenanceScreenings";
import { MiscellaneousNoteForm } from "./components/MiscellaneousNoteForm";
import { useAddMiscellaneousNote } from "./network";

export const HealthMaintenance = () => {
  const { patientId } = useParams({ from: "/patient/$patientId" });
  const [showAddMiscNoteForm, setShowAddMiscNoteForm] = useState(false);
  const { mutate: addMiscellaneousNote, isPending: isAddingMiscellaneousNote } =
    useAddMiscellaneousNote({
      patientId: patientId as string,
      onSuccess: () => {
        toast.success("Miscellaneous note added successfully");
        setShowAddMiscNoteForm(false);
      },
    });
  return (
    <div className="w-full flex flex-col">
      <SectionHeader
        title="Health Maintenance"
        showSeparator={false}
        actionButtons={[
          <DropdownMenu key="add">
            <DropdownMenuTrigger asChild>
              <Button
                variant="icon"
                className="m-0 p-0"
                aria-label="Add health maintenance"
              >
                <Tooltip tooltipContentText="Add" side="bottom" key="add">
                  <CirclePlus className="stroke-link h-4 w-4" />
                </Tooltip>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="w-fit-content">
              <DropdownMenuGroup>
                <DropdownMenuItem
                  key="addMiscellaneousNote"
                  onClick={() => {
                    trackEvent(TRACKERS.ADD_MISCELLANEOUS_NOTE);
                    setShowAddMiscNoteForm(true);
                  }}
                >
                  <NotebookPen size={16} className="mr-2" /> Add Miscellaneous
                  Note
                </DropdownMenuItem>
              </DropdownMenuGroup>
            </DropdownMenuContent>
          </DropdownMenu>,
        ]}
      />
      {showAddMiscNoteForm && (
        <MiscellaneousNoteForm
          onCancel={() => {
            trackEvent(TRACKERS.CANCEL_MISCELLANEOUS_NOTE);
            setShowAddMiscNoteForm(false);
          }}
          onSubmit={(data) => {
            trackEvent(TRACKERS.SAVE_MISCELLANEOUS_NOTE);
            addMiscellaneousNote({
              patientId,
              note: data.text,
            });
          }}
          isSubmitting={isAddingMiscellaneousNote}
        />
      )}
      <HealthMaintenanceMiscellaneous />
      <HealthMaintenanceScreenings />
    </div>
  );
};
